import React from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";


import "chart.js/auto";

const LineChart1 = (props) => {
    const { t } = useTranslation();

  const data = {
    defaultFontFamily: "Poppins",
    labels: ["Jan", "Feb", "Mar", t("hapril"), t("hmay"), "Jun", "Jul", t("haug"), "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "",
        data: props?.data ?? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "#0E46A3",
        borderWidth: props.borderWidth ? props.borderWidth : "4",
        //pointBackgroundColor: "rgba(64, 24, 157, 1)",
        backgroundColor: "rgba(235, 129, 83, 0)",
        tension: 0.4,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        min: 0,
        // max: 100,
        ticks: {
          beginAtZero: true,
          padding: 0,
        },
      },

      x: {
        ticks: {
          padding: 0,
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };
  return (
    <>
      <Line data={data} options={options} height={props.height ? props.height : 100} />
    </>
  );
};

export default LineChart1;
